import { render, staticRenderFns } from "./videoPage.vue?vue&type=template&id=772de4f4&scoped=true"
import script from "./videoPage.vue?vue&type=script&lang=js"
export * from "./videoPage.vue?vue&type=script&lang=js"
import style0 from "./videoPage.vue?vue&type=style&index=0&id=772de4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772de4f4",
  null
  
)

export default component.exports